// extracted by mini-css-extract-plugin
module.exports = {"slider":"Carousel_slider__xXDJc","arrow":"Carousel_arrow__qCfPy","headerPagination":"Carousel_headerPagination__JUZWs"};